var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenido-principal"},[_c('Menu',{attrs:{"token":_vm.token},on:{"salir":_vm.cerrarSesion}}),_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Pie')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }